import eventBus from "./eventBus";

class events {
	createToast({message, stays}) {
		const event = new CustomEvent(eventBus.toast, { detail: {message: message, stays: stays} });
		window.dispatchEvent(event);
	}

	createModal({headline, content, actions, close}) {
		const event = new CustomEvent(eventBus.modal, { detail: { headline, content, actions, close } });
		window.dispatchEvent(event);
	}
}

export default new events();